module.exports = __webpack_public_path__ + "img/u6.d1b315c2.png";